var _ellipse, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.15,
    cx: 16.3821,
    cy: 16.8576,
    rx: 16.3821,
    ry: 16.5714,
    fill: "#166649"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3818 25.7467C11.4652 25.7467 7.49295 21.7745 7.49295 16.8579C7.49295 14.6634 8.2985 12.5801 9.74295 10.969V12.3579H10.8541V9.08008H7.57628V10.1912H8.96517C7.2985 11.9967 6.38184 14.3579 6.38184 16.8579C6.38184 22.3856 10.8818 26.8579 16.3818 26.8579C17.9652 26.8579 19.4652 26.4967 20.8818 25.8023L20.3818 24.8023C19.1318 25.4412 17.7985 25.7467 16.3818 25.7467Z",
    fill: "#004431"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3819 16.8574C26.3819 11.3296 21.8819 6.85742 16.3819 6.85742C14.8264 6.85742 13.3264 7.21853 11.9375 7.8852L12.4375 8.8852C13.6597 8.27409 14.9931 7.96853 16.3819 7.96853C21.2986 7.96853 25.2708 11.9685 25.2708 16.8574C25.2708 19.0519 24.4653 21.1352 23.0208 22.7463V21.3296H21.9097V24.5796H25.1875V23.4685H23.8264C25.4653 21.663 26.3819 19.3296 26.3819 16.8574Z",
    fill: "#004431"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8265 12.1625V13.1625C14.7432 13.4125 14.1598 14.0514 14.0209 14.7181C13.7432 15.8292 14.5209 16.9125 15.8265 17.2459C15.8265 17.2459 16.0765 17.3014 16.3543 17.3848L17.0487 17.5514C17.7154 17.7459 17.882 18.3292 17.8265 18.7459C17.7709 19.1903 17.382 19.6903 16.6876 19.6903C16.3265 19.6903 15.1598 19.4681 14.4932 19.357L14.2709 20.4681C14.382 20.4959 15.1598 20.6348 15.8265 20.7459V21.5792H16.9376V20.8292C17.9654 20.7181 18.7432 19.9959 18.9098 18.9681C19.0765 17.857 18.4376 16.857 17.3543 16.5514C17.3265 16.5514 16.9376 16.4403 16.6043 16.357L16.1043 16.1903C15.2987 15.9681 14.9932 15.4125 15.0765 14.9681C15.2154 14.357 16.2432 13.8848 18.132 14.3014L18.382 13.2181C17.8265 13.107 17.382 13.0514 16.9376 13.0514V12.1348H15.8265V12.1625Z",
    fill: "#004431"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperationIcon);
export default __webpack_public_path__ + "static/media/operation-icon.f6b372d2a8cdd121c843f2abc0ed0f32.svg";
export { ForwardRef as ReactComponent };